import React, { Component } from 'react'
import PropTypes from 'prop-types'

class SmartEndpointErrorBoundary extends Component {
  constructor (props) {
    super(props)
    this.state = { error: null }
  }

  static getDerivedStateFromError (error) {
    return { error }
  }

  componentDidCatch (error, info) {
    console.error('[SmartEndpoints] Uncaught error:', error, info)
  }

  render () {
    if (this.state.error) {
      return (
        <div
          style={{
            padding: 'var(--padding-lg)',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            gap: 'var(--gap-md)',
            color: 'var(--color-neutral-600)',
            marginTop: '80px'
          }}
        >
          <h3 style={{ color: 'var(--color-danger-600)', fontWeight: 600 }}>Something went wrong</h3>
          <p style={{ fontSize: 'var(--text-size-sm)', maxWidth: 480, textAlign: 'center' }}>
            An unexpected error occurred in the Smart Endpoints workspace.
            Try refreshing the page to recover.
          </p>
          <pre
            style={{
              padding: '12px 16px',
              fontSize: '12px',
              fontFamily: 'var(--font-mono, monospace)',
              backgroundColor: 'var(--color-neutral-050)',
              borderRadius: 'var(--border-radius-sm)',
              border: '1px solid var(--color-neutral-200)',
              maxWidth: 600,
              overflow: 'auto',
              color: 'var(--color-danger-700)'
            }}
          >
            {this.state.error.message}
          </pre>
          <button
            onClick={() => this.setState({ error: null })}
            style={{
              padding: '8px 20px',
              fontSize: 'var(--text-size-sm)',
              fontWeight: 600,
              border: '1px solid var(--color-neutral-300)',
              borderRadius: 'var(--border-radius-sm)',
              backgroundColor: 'white',
              cursor: 'pointer',
              color: 'var(--color-neutral-700)'
            }}
          >
            Try Again
          </button>
        </div>
      )
    }
    return this.props.children
  }
}

SmartEndpointErrorBoundary.propTypes = {
  children: PropTypes.node.isRequired
}

export default SmartEndpointErrorBoundary
